import {
    ADD_SKILL_SET,
    ADD_SKILL_SET_SUCCESS,
    FETCH_ALL_SKILL_SET,
    FETCH_ALL_SKILL_SET_SUCCESS,
    EMPTY_SKILL_SET,
    ACTIVATE_SKILL_SET,
    ACTIVATE_SKILL_SET_SUCCESS,
    DEACTIVATE_SKILL_SET,
    DEACTIVATE_SKILL_SET_SUCCESS,
    RESTORE_SKILL_SET_INITIAL,
    FETCH_SKILL_SET_BY_ID,
    FETCH_SKILL_SET_BY_ID_SUCCESS,
    EMPTY_SKILL_SET_BY_ID,
    CREATE_SUBSKILL,
    CREATE_SUBSKILL_SUCCESS,
    FETCH_SUBSKILL_BY_SKILL_ID,
    FETCH_SUBSKILL_BY_SKILL_ID_SUCCESS,
    EMPTY_SUBSKILL_BY_SKILL_ID_SUCCESS,
    FETCH_ALL_TOTAL_SKILLS_DATA,
    FETCH_ALL_TOTAL_SKILLS_DATA_SUCCESS,
    UPDATE_SKILL_SET_SUCCESS,
    UPDATE_SKILL_SET,
    
    UPDATE_SUB_SKILL,
    UPDATE_SUB_SKILL_SUCCESS,
    UPDATE_SUB_SKILL_FAILURE,
    RESET_UPDATE_SUB_SKILL,

    EMPTY_TOTAL_SKILL_SET,
    FETCH_SKILLCENTRES_BY_STATE,
    FETCH_SKILLCENTRES_BY_STATE_SUCCESS,
    EMPTY_SKILLCENTRES_BY_STATE,
    EXPORT_SKILLS,
    EXPORT_SKILLS_SUCCESS,
    PRINT_SKILLS,
    PRINT_SKILLS_SUCCESS,
    UPDATE_MULTIPLE_SUB_SKILLS,
    UPDATE_MULTIPLE_SUB_SKILLS_SUCCESS,
    IMPORT_SKILL_SET,
    IMPORT_SKILL_SET_SUCCESS,
    IMPORT_SUB_SKILL,
    IMPORT_SUB_SKILL_SUCCESS,
} from "../ActionTypes"



// To add new skill set
export const addSkillSet = (payload) => ({  
    type: ADD_SKILL_SET,
    payload
    
});

export const addSkillSetSuccess = payload => ({
    type: ADD_SKILL_SET_SUCCESS,
    payload
});


// To fetch all skill set
export const fetchSkillSet = (payload) => ({
    type: FETCH_ALL_SKILL_SET,
    payload
});

export const fetchSkillSetSuccess = (payload) => ({
    type: FETCH_ALL_SKILL_SET_SUCCESS,
    payload
});

export const emptySkillSet = () =>({
    type: EMPTY_SKILL_SET
});

export const restoreSkillSetInitial = () => ({
    type: RESTORE_SKILL_SET_INITIAL
});

// To Activate and Deactivate skill set
export const activateSkillSet = (id) =>({
    type: ACTIVATE_SKILL_SET,
    payload: id
})

export const activateSkillSetSuccess = (payload) =>({
    type: ACTIVATE_SKILL_SET_SUCCESS,
    payload
})

export const deactivateSkillSet = (id) =>({
    type: DEACTIVATE_SKILL_SET,
    payload:id
})

export const deactivateSkillSetSuccess = (payload) =>({
    type: DEACTIVATE_SKILL_SET_SUCCESS,
    payload
})

// To fetch skill set by id
export const fetchSkillSetById = (id) =>({
    type: FETCH_SKILL_SET_BY_ID,
    payload:id
})

export const fetchSkillSetByIdSuccess = (payload) =>({
    type: FETCH_SKILL_SET_BY_ID_SUCCESS,
    payload
})

export const emptySkillSetById = () => ({
    type: EMPTY_SKILL_SET_BY_ID,
})

// To add subskills
export const addSubSkills = (payload) => ({  
    type: CREATE_SUBSKILL,
    payload
    
});

export const addSubSkillsSuccess = payload => ({
    type: CREATE_SUBSKILL_SUCCESS,
    payload
});

// To fetch subskills by skillid
export const fetchSubSkillBySkillId = (id) =>({
    type: FETCH_SUBSKILL_BY_SKILL_ID,
    payload:id
})

export const fetchSubSkillBySkillIdSuccess = payload =>({
    type: FETCH_SUBSKILL_BY_SKILL_ID_SUCCESS,
    payload
})
    
export const emptySubSkillBySkillId = () => ({
    type: EMPTY_SUBSKILL_BY_SKILL_ID_SUCCESS,
})


// To update skills set
export const updateSkillSet = (payload) =>({
    type: UPDATE_SKILL_SET,
    payload
})
export const updateSkillSetSuccess = (payload) =>({
    type: UPDATE_SKILL_SET_SUCCESS,
    payload
})

// To update sub skill 
export const updateSubSkill = (payload) =>({
    type: UPDATE_SUB_SKILL,
    payload
})
export const updateSubSkillSuccess = (payload) =>({
    type: UPDATE_SUB_SKILL_SUCCESS,
    payload
})

export const updateSubSkillFailure = payload => ({
  type: UPDATE_SUB_SKILL_FAILURE,
  payload
})

export const resetUpdateSubSkill = payload => ({
  type: RESET_UPDATE_SUB_SKILL,
  payload
}) 

// To fetch all total skills data
export const fetchAllTotalSkillsData = () =>({
    type: FETCH_ALL_TOTAL_SKILLS_DATA,
})
export const fetchAllTotalSkillsDataSuccess = (payload) =>({
    type: FETCH_ALL_TOTAL_SKILLS_DATA_SUCCESS,
    payload
})

export const emptyTotalSkillSet = () =>({
    type: EMPTY_TOTAL_SKILL_SET,
});
// To fetch skillCentre by stateid
export const fetchSkillCentreByStateId = (id) =>({
    type: FETCH_SKILLCENTRES_BY_STATE,
    payload:id
})

export const fetchSkillCentreByStateIdSuccess = payload =>({
    type: FETCH_SKILLCENTRES_BY_STATE_SUCCESS,
    payload
})

export const emptySkillCentreByStateId = () =>({
    type: EMPTY_SKILLCENTRES_BY_STATE,
});

// To export all skills as csv
export const exportSkillFile = () =>({
    type: EXPORT_SKILLS
})

export const exportSkillFileSuccess = payload =>({
    type: EXPORT_SKILLS_SUCCESS,
    payload
})

// To print all skills as csv
export const printSkillsPdf = () =>({
    type: PRINT_SKILLS
})

export const printSkillsPdfSuccess = payload =>({
    type: PRINT_SKILLS_SUCCESS,
    payload
})


// To update multiple update sub skills

export const updateMultipleSubSkill = (payload) =>({
    type: UPDATE_MULTIPLE_SUB_SKILLS,
    payload
})

export const updateMultipleSubSkillSuccess = (payload) =>({
    type: UPDATE_MULTIPLE_SUB_SKILLS_SUCCESS,
    payload
})


// Bulk upload for skill set

export const importSkillSet = (payload) =>({
    type: IMPORT_SKILL_SET,
    payload
})

export const importSkillSetSuccess = (payload) =>({
    type: IMPORT_SKILL_SET_SUCCESS,
    payload
})


// Bulk upload for sub skill

export const importSubSkill = (payload) =>({
    type: IMPORT_SUB_SKILL,
    payload
})

export const importSubSkillSuccess = (payload) =>({
    type: IMPORT_SUB_SKILL_SUCCESS,
    payload
})

